export const error = {
  message: 'Error Message',
  close: 'Close',
};
